import { debounce } from 'lodash';
import domReady from '../helpers/dom-ready';

class Menu {
  static init() {
    return new Menu();
  }

  constructor() {
    this.menu = document.querySelector('.brix-menu');

    this.isMenuOpen = false;
    this.isMenuClosing = false;
    this.windowWidth = window.innerWidth;

    this.setUpMenus();
    this.checkOverflow();
    this.checkOpenMenu();
    this.detectUserLanguage();

    window.addEventListener(
      'resize',
      debounce(() => {
        this.windowWidth = window.innerWidth;
        this.checkOverflow();
        this.checkOpenMenu();
      }),
      300,
    );

    let oldScrollValue = 0;
    let newScrollValue = 0;

    window.addEventListener(
      'scroll',
      debounce(() => {
        this.toggleSolidBackground();
        newScrollValue = window.pageYOffset;
        if (
          oldScrollValue < newScrollValue
          && this.menuWrapper.classList.contains('-visible')
        ) {
          this.menuWrapper.classList.remove('-visible');
        } else if (
          oldScrollValue > newScrollValue
          && !this.menuWrapper.classList.contains('-visible')
        ) {
          this.menuWrapper.classList.add('-visible');
        }
        oldScrollValue = newScrollValue;
      }),
      300,
    );
  }

  setUpMenus() {
    this.hamburgerButton = this.menu.querySelector('.menu-button');
    this.menuWrapper = this.menu.querySelector('.menu-wrapper');

    this.hamburgerButton.addEventListener('click', () => {
      if (this.isMenuOpen) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    });

    this.menuWrapper.addEventListener('transitionend', () => {
      if (!this.isMenuOpen && this.windowWidth < 1024) {
        this.closeSubMenus();
      }
    });

    this.hamburgerButton.addEventListener('animationend', () => {
      if (this.isMenuClosing) {
        this.hamburgerButton.classList.remove('-closing');
        this.isMenuClosing = false;
      }
    });

    const primaryMenuItems = this.menu.querySelectorAll('.primary-menu-item');
    this.subMenus = this.menu.querySelectorAll('.sub-menu');

    [...primaryMenuItems].forEach((button) => {
      button.addEventListener('click', () => {
        if (this.menu.classList.contains('-overflow')) {
          const { id } = button.dataset;
          const subMenu = document.querySelector(`.sub-menu[data-id='${id}']`);
          subMenu.classList.toggle('-open');
          button.classList.toggle('-open');

          if (subMenu.classList.contains('-open')) {
            subMenu.style.maxHeight = `${subMenu.scrollHeight + 80}px`;
          } else {
            subMenu.style.maxHeight = '0';
          }
        }
      });
    });
  }

  detectUserLanguage() {
    const translationsLink = document.querySelector('.translation-link');
    if (
      translationsLink
      && navigator.language
      && navigator.language.split('-')[0] !== 'sv'
    ) {
      const url = new URL(translationsLink.href);
      const toLanguageParam = '_x_tr_tl';
      url.searchParams.delete(toLanguageParam);
      url.searchParams.set(toLanguageParam, navigator.language.split('-')[0]);
      translationsLink.href = url;
    }
  }

  toggleSolidBackground() {
    if (window.scrollY > 50) {
      this.menu.classList.add('-solid-background');
      if (!this.menu.classList.contains('-overflow')) {
        setTimeout(() => {
          this.menuWrapper.style.position = 'fixed';
        }, 500);
      }
    } else {
      this.menu.classList.remove('-solid-background');
      if (!this.menu.classList.contains('-overflow')) {
        setTimeout(() => {
          this.menuWrapper.style.position = 'absolute';
        }, 500);
      }
    }
  }

  openMenu() {
    this.hamburgerButton.classList.add('-open');
    this.menuWrapper.classList.add('-open');
    this.menu.classList.add('-open');
    this.isMenuOpen = true;
    this.disableBodyScroll();
  }

  closeSubMenus() {
    [...this.subMenus].forEach((subMenu) => {
      subMenu.classList.remove('-open');
      // eslint-disable-next-line no-param-reassign
      subMenu.style.maxHeight = '0';
      subMenu.parentElement.classList.remove('-open');
    });
  }

  closeMenu() {
    this.isMenuClosing = true;
    this.hamburgerButton.classList.remove('-open');
    this.menuWrapper.classList.remove('-open');
    this.menu.classList.remove('-open');
    this.hamburgerButton.classList.add('-closing');
    this.isMenuOpen = false;
    this.enableBodyScroll();
  }

  checkOverflow() {
    const getHelpButton = this.menuWrapper.querySelector('.get-help-button');
    const primaryMenu = this.menuWrapper.querySelector('.primary-menu');

    if (
      !this.overflowBreakpoint
      && primaryMenu.getBoundingClientRect().right
        > getHelpButton.getBoundingClientRect().right
          - getHelpButton.getBoundingClientRect().width
          - 40
    ) {
      this.overflowBreakpoint = window.innerWidth;
      this.menu.classList.add('-overflow');
    }

    if (
      this.overflowBreakpoint
      && window.innerWidth > this.overflowBreakpoint
    ) {
      this.overflowBreakpoint = null;
      this.menu.classList.remove('-overflow');
    }
  }

  checkOpenMenu() {
    const breakpoint = this.overflowBreakpoint ? this.overflowBreakpoint : 576;

    if (window.innerWidth > breakpoint && this.isMenuOpen) {
      this.openMenu();
    }
  }

  enableBodyScroll() {
    document.body.classList.remove('-scroll-lock');
  }

  disableBodyScroll() {
    document.body.classList.add('-scroll-lock');
  }
}

domReady(() => {
  Menu.init();
});
